module.exports = __webpack_public_path__ + "media/images/front/sp/for-doctors-refine/bg_kv-a585cb1b0f13feb1442a5d8a773e2637.png";